// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1ro-Z","options":"AnswerScale_options__1331N","selected":"AnswerScale_selected__2glTH"};